var data = 
     [{
        resCode:'000000',
        message:'成功',
        list:[
            {
                lotteryName:'FC_SSQ',//彩种
                issue:'20191209',//期号
                items:[
                {

                        itemId:'000006',//商品列表
                        itemName:'大复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'111117',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'111118',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'111119',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'111110',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    }
                    
                ]
            },
            {
                lotteryName:'TC_DLT',//彩种
                issue:'20191209',//期号
                items:[
                {

                        itemId:'000011',//商品列表
                        itemName:'大复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'111122',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'1111123',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'111124',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'111125',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    }
                    
                ]
            },
            {
                lotteryName:'FC_3D',//彩种
                issue:'20191209',//期号
                items:[
                {

                        itemId:'000026',//商品列表
                        itemName:'大复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'111127',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'111128',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'111129',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'111130',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    }
                    
                ]
            }
        ]
    },
    {
        resCode:'000000',
        message:'成功',
        timeId:'111111',
        list:[
            {
                lotteryName:'TC_PL3',//彩种
                issue:'20191209',//期号
                startTime:'2019-12-05 15:30',
                endTime:'2019-12-10 15:30',
                nowTime:'2019-12-09 15:30',
                issueStatus:'1',//1 开期 0 停期 -1 无该彩种数据
                items:[
                {

                        itemId:'000031',//商品列表
                        itemName:'大复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1',//赠送数量
                        schemeId:'123456',//方案id
                        status:'0'//是否可购 0 可购 1 不可购
                    },
                    {
                        itemId:'111132',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'111134',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'111135',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'111136',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    }
                    
                ]
            },
            {
                lotteryName:'FC_K3',//彩种
                issue:'20191209',//期号
                startTime:'2019-12-05 15:30',
                endTime:'2019-12-10 15:30',
                nowTime:'2019-12-09 15:30',
                issueStatus:'1',//1 开期 0 停期 -1 无该彩种数据
                items:[
                {

                        itemId:'000037',//商品列表
                        itemName:'大复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1',//赠送数量
                        schemeId:'123456',//方案id
                        status:'0'//是否可购 0 可购 1 不可购
                    },
                    {
                        itemId:'111138',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'111139',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'111140',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1'//赠送数量
                    },
                    
                ]
            },
            {
                lotteryName:'TC_11X5',//彩种
                issue:'20191209',//期号
                startTime:'2019-12-05 15:30',
                endTime:'2019-12-10 15:30',
                nowTime:'2019-12-09 15:30',
                issueStatus:'1',//1 开期 0 停期 -1 无该彩种数据
                items:[
                {

                        itemId:'000050',//商品列表
                        itemName:'大复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        giveNumber:'1',//赠送数量
                        schemeId:'123456',//方案id
                        status:'0'//是否可购 0 可购 1 不可购
                    },
                    {
                        itemId:'111151',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        schemeId:'123490',//方案id

                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'111531',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        schemeId:'123491',//方案id

                        giveNumber:'1'//赠送数量
                    },
                    {
                        itemId:'111541',//商品列表
                        itemName:'小复式12+3',//商品名称
                        price:'1.18',//商品价格
                        giveType:'0',//赠送类型 0 不赠送  1 赠送
                        schemeId:'123499',//方案id

                        giveNumber:'1'//赠送数量
                    }
                    
                ]
            }
        ]
    }
]

export default {
    data
} 


// WEBPACK FOOTER //
// ./src/views/LuckyNumPay/list.js